import { ITranslationResponse } from "../../models/base/translation";
import { languages } from "./constants";

export const getTranslations = (translation?: ITranslationResponse[]) => {
  if (!translation) return null;
  if (!Array.isArray(translation)) return null;
  return translation.reduce(
    (prev, { lang, value }) => ((prev[lang] = value), prev),
    {} as any
  );
};
export const getDumpTranslations = (translation?: ITranslationResponse[]) => {
  let step = translation;
  if (translation) {
    for (const [key, value] of Object.entries(translation)) {
      if (!value) {
        step[key] = "empty note";
      }
    }

    return step;
  }
  return null;
};

/**
 * Extracts a label value from a localized name field.
 * Handles cases where the name can be:
 * - A plain string
 * - An array of {lang, value} objects
 * - An object with translations
 * @param name - The name field which could be string, array, or object
 * @param fallback - Fallback text if no label can be extracted
 */
export const extractLabelFromName = (
  name: any,
  fallback?: string
): string => {
  if (typeof name === "string") {
    return name;
  }
  if (Array.isArray(name)) {
    return name[0]?.value || fallback || "";
  }
  if (name && typeof name === "object") {
    return name.ar || name.en || fallback || "";
  }
  return fallback || "";
};
